import { createFileRoute } from '@tanstack/react-router';

import { BargeControlRoute } from './-bargeControl/BargeControlRoute.tsx';

export const Route = createFileRoute('/(app)/bargeControl')({
  component: BargeControlRoute,
});
